/* unplugin-vue-components disabled */import script from "./comprehensiveQuality.vue?vue&type=script&setup=true&lang=js"
export * from "./comprehensiveQuality.vue?vue&type=script&setup=true&lang=js"

import "./comprehensiveQuality.vue?vue&type=style&index=0&id=52b091c4&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-52b091c4"]])

export default __exports__